"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSecurityAppActiveStatusType = void 0;
var DataSecurityAppActiveStatusType;
(function (DataSecurityAppActiveStatusType) {
    DataSecurityAppActiveStatusType["Unknown"] = "unknown";
    DataSecurityAppActiveStatusType["Operational"] = "operational";
    DataSecurityAppActiveStatusType["Minor"] = "minor";
    DataSecurityAppActiveStatusType["Major"] = "major";
    DataSecurityAppActiveStatusType["Critical"] = "critical";
})(DataSecurityAppActiveStatusType || (exports.DataSecurityAppActiveStatusType = DataSecurityAppActiveStatusType = {}));
//# sourceMappingURL=DataSecurityAppActiveStatus.js.map